module.exports = __webpack_public_path__ + "01f43047/img/trash-icon.ff8201c7.svg";